import React from 'react'

export type CheckpointsIconProps = {
  size?: number
  color?: string
  className?: string
}

export const CheckpointsIcon = ({
  size = 20,
  color = 'currentColor',
  className,
}: CheckpointsIconProps) => (
  <svg
    aria-label='Checkpoints'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M0 0h24v24H0z' fill='none' />
    <path
      d='M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM19 19h2v2h-2zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2z'
      fill={color}
    />
  </svg>
)
